import { Table, type TableProps } from './src/Table';
import { TableBody, type TableBodyProps } from './src/TableBody';
import { TableRow, type TableRowProps } from './src/TableRow';
import { TableCell, type TableCellProps } from './src/TableCell';
import { TableHeader, type TableHeaderProps } from './src/TableHeader';
import {
  TableHeaderCell,
  type TableHeaderCellProps,
} from './src/TableHeaderCell';
import { TableHeaderRow, type TableHeaderRowProps } from './src/TableHeaderRow';
import { TableContainer, type TableContainerProps } from './src/TableContainer';

import { type ColumnAlignment, type ColSizeProps } from './src/utils';
import { useTableRowContext } from './src/TableRowContext';
import { TableFooter } from './src/TableFooter';

const _Table = Object.assign(Table, {
  Body: TableBody,
  Row: TableRow,
  Cell: TableCell,
  Header: TableHeader,
  HeaderCell: TableHeaderCell,
  HeaderRow: TableHeaderRow,
  Container: TableContainer,
  Footer: TableFooter,
});

export { _Table as Table, useTableRowContext };
export {
  TooltipIfNeeded,
  type TooltipIfNeededProps,
} from './src/TooltipIfNeeded';

export interface ColStyleProps {
  align?: ColumnAlignment;
  overflow?: CellOverflow;
}

export type CellOverflow = 'wrap' | 'truncate';
export type CellSpacing = 'sm' | 'md' | 'lg' | 'xl';

export type StickyPosition = 'auto' | boolean;

export type {
  TableProps,
  TableBodyProps,
  TableRowProps,
  TableCellProps,
  TableHeaderProps,
  TableHeaderCellProps,
  TableHeaderRowProps,
  ColSizeProps,
  ColumnAlignment,
  TableContainerProps,
};
